module.exports = __webpack_public_path__ + "img/12.4.NH3-N.0d31dc15.png";